import React from "react";
import {relayAuthEnvironment, relayGuestEnvironment} from "@/RelayEnvironment";
import { Environment, QueryRenderer } from "react-relay";
import { graphql } from "relay-runtime";
import { UserTokenQueryRendererQuery } from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenQueryRendererQuery.graphql";
import {
    UserTokenMainQueryRendererQueryResponse,
} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenMainQueryRendererQuery.graphql";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import UserTokenView from "@/Domains/AuthenticationManagement/Usertoken/Views/UserTokenView";
import UserTokenInvalid from "@/Domains/AuthenticationManagement/Usertoken/Forms/UserTokenInvalid";
import LoadingElement from "@/Components/Loading/LoadingElement";

interface IUserTokenSearchQueryRenderer {
    viewData: UserTokenMainQueryRendererQueryResponse;
    token: string;
}

const UserTokenSearchQueryRenderer: React.FunctionComponent<
    IUserTokenSearchQueryRenderer
> = ({ viewData,token }): JSX.Element => {
    const { t } = useTranslation();
    return (
        <QueryRenderer<UserTokenQueryRendererQuery>
            //@ts-ignore
            environment={relayGuestEnvironment() as Environment}
            query={graphql`
                query UserTokenQueryRendererQuery(                 
                    $token: String!
                ) {
                    userTokenValid(token: $token)
                }
            `}
            cacheConfig={{ force: true }}
            variables={{
                token: token
            }}
            render={(result) => {
                if (result.error) {
                    return <> {t("general.errors.generalError")}</>;
                }

                if (!result.props) {
                    return <LoadingElement/>;
                }

                if (!result.props?.userTokenValid) {
                    return <UserTokenInvalid/>;
                }

                return (
                    <>
                        <UserTokenView
                            // @ts-ignore
                            viewData={viewData}
                            token={token}
                        />
                    </>
                );
            }}
        />
    );
};

export default UserTokenSearchQueryRenderer;
